module.exports = __webpack_public_path__ + "assets/trash.50ff4b7b.svg";